import { render, staticRenderFns } from "./sales_report.vue?vue&type=template&id=2bb149d8&"
import script from "./sales_report.vue?vue&type=script&lang=js&"
export * from "./sales_report.vue?vue&type=script&lang=js&"
import style0 from "./sales_report.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports